(() => {
  const PLANS = [
    {months: 3, rate: 0.02, adminFee: 99.5, rateLabel: "2.0%"},
    {months: 6, rate: 0.05, adminFee: 199.5, rateLabel: "5.00%"},
    {months: 12, rate: 0.0885, adminFee: 299.5, rateLabel: "8.85%"},
  ] as const;

  function fmt(n: number): string {
    return n.toLocaleString("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 0});
  }

  function fmtDecimal(n: number): string {
    return n.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function render(monthlyRent: number | null) {
    const label = document.getElementById("ar-calc-label");
    if (label) {
      label.textContent = monthlyRent ? `Based on ${fmtDecimal(monthlyRent)}/mo monthly rent` : "Estimated payouts";
    }

    for (const plan of PLANS) {
      const payoutEl = document.getElementById(`ar-payout-${plan.months}`);
      const grossEl = document.getElementById(`ar-gross-${plan.months}`);
      const rateFeeEl = document.getElementById(`ar-ratefee-${plan.months}`);
      const netEl = document.getElementById(`ar-net-${plan.months}`);

      if (!payoutEl || !grossEl || !rateFeeEl || !netEl) {
        continue;
      }

      if (!monthlyRent) {
        payoutEl.textContent = "— — —";
        grossEl.textContent = "—";
        rateFeeEl.textContent = "—";
        netEl.textContent = "—";
        continue;
      }

      const totalRent = monthlyRent * plan.months;
      const rateFee = totalRent * plan.rate;
      const payout = totalRent - rateFee - plan.adminFee;

      if (payout <= 0) {
        payoutEl.textContent = "— — —";
        grossEl.textContent = "—";
        rateFeeEl.textContent = "—";
        netEl.textContent = "—";
        continue;
      }

      payoutEl.textContent = fmt(payout);
      payoutEl.classList.remove("ar-pop");
      void payoutEl.offsetWidth;
      payoutEl.classList.add("ar-pop");

      grossEl.textContent = fmt(totalRent);
      rateFeeEl.textContent = `−${fmtDecimal(rateFee)}`;
      netEl.textContent = fmt(payout);
    }
  }

  const MAX_RENT = 100_000;

  function init() {
    const input = document.getElementById("ar-calc-input") as HTMLInputElement | null;
    if (!input) {
      return;
    }

    input.value = (2000).toLocaleString("en-US");
    render(2000);

    input.addEventListener("input", () => {
      const raw = input.value.replace(/[^0-9.]/g, "");
      const parsed = Number.parseFloat(raw);

      if (!Number.isNaN(parsed) && parsed > 0) {
        const capped = Math.min(parsed, MAX_RENT);
        input.value = Math.floor(capped).toLocaleString("en-US");
        render(capped);
      } else {
        input.value = raw;
        render(null);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
